import clsx from "clsx";
import React from "react";
import { bool, func } from "prop-types";
import Checkbox from "@material-ui/core/Checkbox";
import TableCell from "./TableCell";

const TableRow = ({ index, children, onClick, onDoubleClick, checkable, checked, onCheckedChange, ...props }) => {
    return (
        <tr
            className={clsx("table__row table__row--click", { "table__row--checked": checked })}
            onClick={onClick}
            onDoubleClick={onDoubleClick}
            role="checkbox"
            aria-checked={checked}
            {...props}
        >
            <TableCell onClick={onCheckedChange}>
                {checkable && <Checkbox color="primary" checked={checked} inputProps={{ "aria-labelledby": `table-checkbox-${index}` }} />}
            </TableCell>
            {children}
        </tr>
    );
};

TableRow.propTypes = {
    checkable: bool,
    checked: bool,
    onCheckedChange: func,
};
TableRow.defaultProps = { checkable: true, checked: false, onCheckedChange: undefined };

export default TableRow;
